import { useState, useEffect } from "react";
import { API, axios } from "@/api";
import { Loader2, SlidersHorizontal } from "lucide-react";

export default function FilterAnalyticsPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/filter-analytics`)
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-8"><Loader2 className="w-5 h-5 animate-spin text-slate-300" /></div>;
  if (!data) return <p className="text-sm text-slate-400 text-center py-4">Failed to load</p>;

  const { total_filter_uses, total_sessions, filters } = data;

  if (filters.length === 0) {
    return (
      <div className="text-center py-8" data-testid="filter-analytics-panel">
        <SlidersHorizontal className="w-8 h-8 text-slate-200 mx-auto mb-2" />
        <p className="text-sm text-slate-400">No filter usage data yet</p>
        <p className="text-xs text-slate-300 mt-1">As users apply filters, you'll see which ones are most popular here</p>
      </div>
    );
  }

  const maxUses = filters.length > 0 ? filters[0].uses : 1;

  return (
    <div className="space-y-3" data-testid="filter-analytics-panel">
      <div className="grid grid-cols-2 gap-2">
        <div className="bg-indigo-50 rounded-xl p-3 text-center border border-indigo-100">
          <p className="text-lg font-bold text-indigo-700">{total_filter_uses}</p>
          <p className="text-[10px] text-indigo-500 font-medium">Filter Toggles</p>
        </div>
        <div className="bg-slate-50 rounded-xl p-3 text-center border border-slate-200">
          <p className="text-lg font-bold text-slate-700">{total_sessions}</p>
          <p className="text-[10px] text-slate-500 font-medium">Sessions</p>
        </div>
      </div>

      <div className="space-y-2">
        {filters.map((f) => (
          <div key={f.filter} className="flex items-center gap-3" data-testid={`filter-stat-${f.filter}`}>
            <span className="text-xs font-medium text-slate-600 w-28 truncate">{f.filter}</span>
            <div className="flex-1 h-5 bg-slate-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-indigo-400 rounded-full transition-all duration-500"
                style={{ width: `${Math.max((f.uses / maxUses) * 100, 3)}%` }}
              />
            </div>
            <span className="text-[10px] font-semibold text-slate-500 w-10 text-right">{f.uses}</span>
            <span className="text-[10px] text-slate-400 w-10 text-right">{f.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
